import { OutDebt, NegotiationOption } from '../generated/graphql';
import { getNegBooleans } from './getNegBooleans';

export const getContentExtraBankNegType = (outDebt: OutDebt, option: NegotiationOption) => {
  const {
    isRappiPay,
    isPichincha,
    isInstallmentsPlan,
    isExpressRefinance,
  } = getNegBooleans(outDebt, option);
  const fallenSub = outDebt.extra?.isFallen ? '_fallen' : '';
  return (isRappiPay && isInstallmentsPlan) || (isPichincha && isExpressRefinance) ? `_${option.type}${fallenSub}` : `${fallenSub}`;
};
